export default __webpack_public_path__ + "static/media/footer-bg.289aeca7.png";